import { http, HttpResponse } from 'msw';

const BASE = import.meta.env?.VITE_API_BASE_URL ?? 'http://localhost:8000';

let mfaEnabled = false;

export const demoMfaHandlers = [
  // ── MFA status ────────────────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/auth/mfa/status`, () => {
    return HttpResponse.json({
      enabled: mfaEnabled,
      enrolled_at: mfaEnabled ? '2026-02-20T14:30:00Z' : null,
    });
  }),

  // ── MFA enroll ────────────────────────────────────────────────────────────
  http.post(`${BASE}/api/v1/auth/mfa/enroll`, () => {
    return HttpResponse.json({
      provisioning_uri:
        'otpauth://totp/TradeSentinel:demo@example.com?secret=DEMOSECRETBASE32KEY&issuer=TradeSentinel',
      backup_codes: [
        'DEMO-A1B2-C3D4',
        'DEMO-E5F6-G7H8',
        'DEMO-I9J0-K1L2',
        'DEMO-M3N4-O5P6',
        'DEMO-Q7R8-S9T0',
        'DEMO-U1V2-W3X4',
        'DEMO-Y5Z6-A7B8',
        'DEMO-C9D0-E1F2',
      ],
    });
  }),

  // ── MFA verify enrollment ─────────────────────────────────────────────────
  http.post(`${BASE}/api/v1/auth/mfa/verify-enrollment`, () => {
    mfaEnabled = true;
    return HttpResponse.json({ success: true });
  }),

  // ── MFA verify (login step) ───────────────────────────────────────────────
  http.post(`${BASE}/api/v1/auth/mfa/verify`, () => {
    return HttpResponse.json({ success: true });
  }),

  // ── MFA disable ───────────────────────────────────────────────────────────
  http.delete(`${BASE}/api/v1/auth/mfa`, () => {
    mfaEnabled = false;
    return new HttpResponse(null, { status: 204 });
  }),

  // ── Regenerate backup codes ───────────────────────────────────────────────
  http.post(`${BASE}/api/v1/auth/mfa/backup-codes`, () => {
    return HttpResponse.json({
      backup_codes: [
        'NEW1-A1B2-C3D4',
        'NEW2-E5F6-G7H8',
        'NEW3-I9J0-K1L2',
        'NEW4-M3N4-O5P6',
        'NEW5-Q7R8-S9T0',
        'NEW6-U1V2-W3X4',
        'NEW7-Y5Z6-A7B8',
        'NEW8-C9D0-E1F2',
      ],
    });
  }),
];
